
/*eslint-disable*/
/**
 * 向后端请求用户的菜单，动态生成路由
 */
import router, { resetRouter } from '@/router'
import { asyncRouterMap, constantRouterMap } from '@/config/router.config'
import { generatorDynamicRouter } from '@/router/generator-routers'
import storage from 'store2'
import { CURRENT_NAV, DEFAULT_SYSTEM_TYPE, DYNAMIC_ROUTERS, TOP_NAV, DEFAULT_ROUTER, PROJECT_CENTER_PERMISSION, PROJECT_CREATE_PERMISSION } from '../mutation-types'
import cloneDeep from 'lodash.clonedeep'

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    dynamicRouters: storage.session.get(DYNAMIC_ROUTERS) || [],
    defaultSystemType: storage.session.get(DEFAULT_SYSTEM_TYPE) || '',
    topNav: storage.session.get(TOP_NAV) || [],
    currentNav: storage.get(CURRENT_NAV) || '',
    defaultRouter: storage.session.get(DEFAULT_ROUTER) || '',
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    },
    SET_DYNAMIC_ROUTERS: (state, routers) => {
      state.dynamicRouters = routers
      storage.session.set(DYNAMIC_ROUTERS, routers)
    },
    SET_DEFAULT_SYSTEM_TYPE: (state, type) => {
      state.defaultSystemType = type
      storage.session.set(DEFAULT_SYSTEM_TYPE, type)
    },
    SET_TOP_NAV: (state, nav) => {
      state.topNav = nav
      storage.session.set(TOP_NAV, nav)
    },
    SET_CURRENT_NAV: (state, key) => {
      state.currentNav = key
      storage.set(CURRENT_NAV, key)
    },
    SET_DEFAULT_ROUTER: (state, path) => {
      state.defaultRouter = path
      storage.session.set(DEFAULT_ROUTER, path)
    },
  },
  actions: {
    Generate ({ commit }, data) {
      return new Promise(resolve => {
        // const { token, systemType } = data // systemType 是需要切换左侧菜单的系统模块类型
        // generatorDynamicRouter(token, systemType).then(routers => {
        const { userId } = data // systemType 是需要切换左侧菜单的系统模块类型
        generatorDynamicRouter(userId).then(({ routers, dynamicRouters }) => {
          console.log('SET_ROUTERS', routers)
          commit('SET_ROUTERS', routers)
          if (dynamicRouters) {
            console.log('DYNAMIC_ROUTERS', dynamicRouters)
            commit('SET_DYNAMIC_ROUTERS', dynamicRouters)
          }
          resolve()
        })
      })
    },
    // GenerateRoutes ({ commit }, data) {
    //   return new Promise((resolve, reject) => {
    //     const { token } = data
    //     generatorDynamicRouter(token).then(routers => {
    //       commit('SET_ROUTERS', routers)
    //       resolve()
    //     }).catch(e => {
    //       reject(e)
    //     })
    //   })
    // },
    SetAuthType ({ commit }, data) {
      commit('SET_DEFAULT_SYSTEM_TYPE', data.systemType)
    },
    ClearRoutes ({ commit }) {
      commit('SET_ROUTERS', [])
      commit('SET_TOP_NAV', [])
      commit('SET_DYNAMIC_ROUTERS', [])
    },
    // 拉取全部子系统路由并生成当前子系统路由
    GenerateRoutes ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        // const { userId } = data
        // if (!userId) {
        //   dispatch('Logout')
        // }
        generatorDynamicRouter().then(({routers, topNav, error}) => {
          // console.log('async-router1111111111', routers)
          if (!error) {
            console.log('SET_ROUTERS', routers)
            commit('SET_ROUTERS', routers)
            if (topNav) {
              if (topNav instanceof Array && topNav.length > 0) {
                console.log('topNav', topNav)
                commit('SET_TOP_NAV', topNav)
              } else {
                error = '当前账号未被分配资源，请联系管理员'
              }
            }
          }
          if (!error) {
            resolve({
              routers,
              topNav,
              error
            })
          } else {
            dispatch('ResetToken', '')
            reject(new Error(error))
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 设置默认选中的头部导航条
    SetCurrentNav ({ commit }, key) {
      commit('SET_CURRENT_NAV', key)
    },
    // 设置默认路由
    SetDefaultRouter ({ commit }, key) {
      commit('SET_DEFAULT_ROUTER', key)
    }
  }
}

export default permission
